import { make } from "vuex-pathify";

const state = {
    items: []
};

const mutations = make.mutations(state);

const actions = {
    fetch({ rootState }) {
        let items = [
            {
                url: "/",
                name: "Home",
                slug: "home",
                icon: "HomeIcon"
            },
            {
                url: "/searches",
                name: "Pesquisas Gravadas",
                slug: "searches",
                icon: "BookmarkIcon"
            },
            {
                url:"/favorites",
                name:"Meus Favoritos",
                slug:"home",
                icon:"StarIcon"
            }
        ];

        const isAdmin = rootState.user.model.groupAlias === "administrator";

        if (isAdmin) {
            items.push({
                url: "/manage-documents",
                name: "Gerenciar Documentos",
                slug: "manage-documents",
                icon: "ClipboardIcon"
            });

            items.push({
                url: "/users",
                name: "Usuários",
                slug: "users",
                icon: "UserIcon"
            });
        }

        this.set("menu/items", items);
    },
    reset() {
        this.set("menu/items", []);
    }
};

export default { state, mutations, actions };
